import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import { Link } from 'react-router-dom'
import { Button, Confirm, Icon, Input, Table } from 'semantic-ui-react'
import { authHeader, history } from '../../_helpers'
import ReactLoading from "react-loading"
import { getEducationalList, deleteEducationData } from '../../actions/EducationActions'
import Pagination from 'react-js-pagination'
import { itemsCountPerPage, pageRangeDisplayed, pageSize } from '../../constants/HelperConstants'

const EducationContainer = (props) => {
    let pathname = props.location.pathname
    const { getEducationalList, educationList, deleteEducationData, loading, error, count } = props
    const [deleteValue, setDeleteValue] = useState(true)
    const [open, setOpen] = useState(true)
    const [currentUserId, setCurrentUserId] = useState(null)
    const [activePage, setActivePage] = useState(1)
    const [searchTerm, setSearchTerm] = useState("")

    useEffect(() => {
        if(authHeader){
            if(localStorage.getItem('token')){
                authHeader(pathname)
                getEducationalList(activePage, searchTerm)
            }
            else{
                history.push('/login') 
            }
        }
    }, [getEducationalList, pathname, activePage, searchTerm])

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber)
    }

    const handleChange = (event) => {
        const target =  event.target
        const { value } = target
        setSearchTerm(value)
    }

    const deleteEducation = (id) => {
        setDeleteValue(false)
        setOpen(true)
        setCurrentUserId(id)
    }

    const confirmDelete = (id) => {
        return (
            <Confirm open={open}
                    content='Are you sure want to delete this Education?'
                    onCancel={close}
                    className="delete-popup"
                    cancelButton='No, cancel it!'
                    confirmButton="Yes, delete it!"
                    onConfirm={() => renderDeleteEducation(id)} />
        )
    }

    const close = () => {
        setOpen(false)
        setDeleteValue(true)
    }

    const renderDeleteEducation = (id) => {
        deleteEducationData(id)
        setOpen(false)
    }

    const getTableBody = () => {
        let serialNo = ((activePage - 1) * pageSize) + 1
        return(
            educationList.map((data, index) => {
                return(
                    <Table.Row key={data.id} className="form-data">
                        <Table.Cell> {serialNo + index} </Table.Cell>
                        <Table.Cell> {data.name} </Table.Cell>
                        <Table.Cell> {data.display_name} </Table.Cell>
                        <Table.Cell> {data.rank} </Table.Cell>
                        <Table.Cell>
                            <Link to={{ pathname: `/editeducation/${data.id}`}}>
                                <Button icon className="edit-btn">
                                    <Icon name='edit' />
                                </Button>
                            </Link>
                            <Button icon onClick={() => deleteEducation(data.id)} className="delete-btn">
                                <Icon name='trash' />
                            </Button>
                        </Table.Cell>
                    </Table.Row>
                )
            })
        )
    }

    const getTable = () => {
        return(
            <Table basic='very'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell> S.No </Table.HeaderCell>
                        <Table.HeaderCell> Disability name </Table.HeaderCell>
                        <Table.HeaderCell> Display Name </Table.HeaderCell>
                        <Table.HeaderCell> Rank </Table.HeaderCell>
                        <Table.HeaderCell> Actions </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {getTableBody()}
                    {deleteValue === false ? confirmDelete(currentUserId) : null}
                </Table.Body>
            </Table>
        )
    }

    return(
        <div className="wrapper">
            <div className="container">
                <Header />
                <Link className="link-container exam-content" to="/dashboard">
                    <Icon name="arrow left" />
                    Back to Dashboard
                </Link>
                <div>
                    <Input type="text"
                           placeholder="Enter text"
                           className="search-box"
                           onChange={handleChange}
                           action={{
                            color: "blue",
                            icon: "search"
                          }}
                           value={searchTerm} />
                    <Link to="/addeducation">
                        <Button primary floated='right' className="add-btn">
                            <Icon name="plus" />
                            Add Education
                        </Button>
                    </Link>
                </div>
                {loading ? <ReactLoading className="loader-container" type="spin" color="#007bff" height={30} width={30} /> : null}
                {error !== "" ? <h3 className="errorMsg"> {error} </h3> : null}
                {educationList !== undefined ? educationList.length !== 0 ? getTable() : <h3> No Data </h3> :null}
                <div>
                    {error === "" && count.length > pageSize ?
                    <Pagination activePage={activePage}
                                itemsCountPerPage={itemsCountPerPage}
                                totalItemsCount={count.length}
                                pageRangeDisplayed={pageRangeDisplayed}
                                onChange={handlePageChange} />
                    : error}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    educationList: state.educationReducer.educationList,
    loading: state.educationReducer.loading,
    error: state.educationReducer.error,
    count: state.educationReducer.count
})

const mapDispatchToProps = {
    getEducationalList,
    deleteEducationData
}

export default connect(mapStateToProps, mapDispatchToProps)(EducationContainer)